import {types} from '../../types';

const setGetListOrganizationAction = (payload) => {
    return {
        type: types.common.SET_LIST_ORGANIZATION,
        payload,
      }
}

export {
  setGetListOrganizationAction as SetGetListOrganizationAction
}
